// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DonateButton__container-d51648 {
  display: flex;
  justify-content: center;
  align-self: center;
  background-color: var(--base-15);
  border-radius: 25px;
}

.DonateButton__title-da5d1e {
  font: var(--font-body-2);
  letter-spacing: var(--font-spacing-body-2);
  color: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatHeader/DefaultHeader/DefaultHeaderActions/DonateButton/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,mBAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  align-self: center;\n  background-color: var(--base-15);\n  border-radius: 25px;\n}\n\n.title {\n  font: var(--font-body-2);\n  letter-spacing: var(--font-spacing-body-2);\n  color: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DonateButton__container-d51648`,
	"title": `DonateButton__title-da5d1e`
};
module.exports = ___CSS_LOADER_EXPORT___;
